export const TITLE = 'Mind the Graph';

export const DESCRIPTION =
  'Build beautiful scientific, academic and educational infographics and presentations with this and other 8,500+ accurate illustrations from Mind the Graph.';
